import { Controller } from "@hotwired/stimulus";

import * as Charts from "../../radio_airplay/airplay_charts";
// { overall
// likes
// heatmap
//  wax }

export default class extends Controller {
  static values = {
    reportType: String,
    reportUrl: String,
  };

  connect() {
    console.log(
      "connect airplay reports",
      this.reportTypeValue,
      this.reportUrlValue
    );
    Charts[this.reportTypeValue](this.reportUrlValue);
  }
}
